import { orderBy, uniq } from 'lodash';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

// This function will sort a list of variants such that variants with reported
// operations are at the beginning of the list and the rest are alphabetically sorted.
export function sortByStatsData(
  variants: string[],
  operationCheckRequestsByVariant?: Array<GraphQLTypes.ChecksConfigPageStatsQuery_service_operationCheckRequestsByVariant> | null,
): string[] {
  return uniq([
    ...((operationCheckRequestsByVariant || []).map(
      (qs) => qs.variant || 'current',
    ) ?? []),
    ...orderBy(variants, [(variant) => variant], 'asc'),
  ]);
}

// Builds map of variant name to stats (request counts)
export function buildStatsMap(
  operationCheckRequestsByVariant?: Array<GraphQLTypes.ChecksConfigPageStatsQuery_service_operationCheckRequestsByVariant> | null,
): Map<
  string,
  GraphQLTypes.ChecksConfigPageStatsQuery_service_operationCheckRequestsByVariant
> {
  const variantStatsMap = new Map();
  (operationCheckRequestsByVariant || []).forEach((stat) => {
    const variant = stat.variant || 'current';
    variantStatsMap.set(variant, stat);
  });
  return variantStatsMap;
}
